export const FORBIDDEN_PREFIXES = [
  "account",
  "accounts",
  "admin",
  "finance",
  "support",
  "contact",
];
